import GS from '../../grafsync/grafsync';
import cloneDeep from 'lodash/cloneDeep';
import * as d3 from "d3";

const CLASS_CONFIGURATION = [
    {
        type: "ConceptScheme",
        text: "Concept Scheme",
        svg: "M16 16c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zM6 12c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm8.5-10C17.538 2 20 4.462 20 7.5S17.538 13 14.5 13 9 10.538 9 7.5 11.462 2 14.5 2z",
        transform: "translate(-22 -22) scale(1.8 1.8)"
    },
    {
        type: "Concept",
        text: "Concept",
        svg: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        transform: "translate(-24 -24) scale(2 2)"
    },
    {
        type: "Ontology",
        text: "Ontology",
        svg: "M16.047,10.105a3.045,3.045,0,0,0-3.217,1.116l-3.362-.893-.323-2.8a3.485,3.485,0,0,0-.4-6.626A3.541,3.541,0,0,0,4.41,3.384a3.5,3.5,0,0,0,2.5,4.293c.073.02.146.021.218.036L7.475,10.7,4.345,14.841a2.5,2.5,0,1,0,1.92,3.088A2.475,2.475,0,0,0,5.993,16l2.849-3.766,3.4.9a3,3,0,0,0,2.231,2.771,3.036,3.036,0,0,0,3.715-2.124A3,3,0,0,0,16.047,10.105Z",
        transform: "translate(-18 -22) scale(2 2)"
    },
    {
        type: "OwlClass",
        text: "OWL Class",
        svg: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        transform: "translate(-24 -24) scale(2 2)"
    },
    {
        type: "ObjectProperty",
        text: "Object Property",
        svg: "M7.77 6.76 6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z",
        transform: "translate(-24 -24) scale(2 2)"
    },
    {
        type: "DatatypeProperty",
        text: "Datatype Property",
        svg: "M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z",
        transform: "translate(-24 -24) scale(2 2)"
    },
    {
        type: "AnnotationProperty",
        text: "Annotation Property",
        svg: "M16 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8l-5-5zM7 7h5v2H7V7zm10 10H7v-2h10v2zm0-4H7v-2h10v2zm-2-4V5l4 4h-4z",
        transform: "translate(-24 -24) scale(2 2)"
    }
];

async function createVisual(el, originalNode, graph, loadCallback, objectProperties,
    defaultLang = "en", viewLang = "en", configuration = {}) {

    const width = el.getBoundingClientRect().width;
    const height = el.getBoundingClientRect().height;
    const radius = 30;
    const ALPHA_TARGET = 0.05;

    let svg = d3.select(el);
    let div = d3.select("#visual-tooltip");

    let g;
    let showTooltips = true;
    let zoomHandler;
    let zoomFactor = 1;
    let zoomEnabled = true;
    let simulation;
    let resources = [];
    let node = [];
    let link = [];
    let edgepaths = [];
    let edgelabels = [];
    let linkStore = [];
    let nodeStore = [];
    let monitorGuids = [];
    let monitorIRIs = [];
    let configurationIRIs = Object.getOwnPropertyNames(configuration).map(cp => configuration[cp].iri);

    const curve = d3.line().curve(d3.curveNatural);
    const MAX_CONNECTIONS = 100;

    function edgeCurve(d) {

        const sourceX = d.source.x;
        const targetX = d.target.x;
        const sourceY = d.source.y;
        const targetY = d.target.y;
        const ROTATE = .34;

        const cf = d.nodeLinkIndex;

        const midPointX = Math.abs(sourceX - targetX) / 2;
        const midPointY = Math.abs(sourceY - targetY) / 2;
        let rotatedX = midPointX;
        let rotatedY = midPointY;
        if (cf > 0) {
            rotatedX = midPointX * Math.cos(ROTATE * cf) - midPointY * Math.sin(ROTATE * cf);
            rotatedY = midPointY * Math.cos(ROTATE * cf) + midPointX * Math.sin(ROTATE * cf);
        }
        if (targetX < sourceX) {
            if (targetY < sourceY) {
                return curve([
                    [targetX, targetY],
                    [targetX + rotatedX, targetY + rotatedY],
                    [sourceX, sourceY]
                ]);
            }
            else {
                return curve([
                    [targetX, targetY],
                    [targetX + rotatedX, targetY - rotatedY],
                    [sourceX, sourceY]
                ]);
            }
        }
        else {
            if (targetY < sourceY) {
                return curve([
                    [sourceX, sourceY],
                    [targetX - rotatedX, targetY + rotatedY],
                    [targetX, targetY]
                ]);
            }
            else {
                return curve([
                    [sourceX, sourceY],
                    [targetX - rotatedX, targetY - rotatedY],
                    [targetX, targetY]
                ]);
            }
        }
    }

    function tickActions() {

        node.select("circle")
            .attr("class", d => {
                if (d.id !== originalNode) {
                    const ci = d.nodeClass.find(classItem => CLASS_CONFIGURATION.some(cc => cc.type === classItem));
                    if (resources.includes(d.id)) {
                        if (ci) return "visual-" + ci + ' visual-node';
                        else return "visual-default visual-node";
                    }
                    else {
                        if (ci) return "visual-unloaded-" + ci + ' visual-node';
                        else return "visual-unloaded-default visual-node";
                    }
                }
                else return "visual-startNode";
            });

        node.attr("transform", d => "translate(" + d.x + ", " + d.y + ")");

        link
            .attr('marker-start', d => d.target.x < d.source.x ?
                configuration.hasOwnProperty(d.type) ?
                    `url(#arrowhead-${d.type})`
                    :
                    `url(#arrowhead)`
                :
                null
            )
            .attr('marker-end', d => d.target.x > d.source.x ?
                configuration.hasOwnProperty(d.type) ?
                    `url(#reverseArrowhead-${d.type})`
                    :
                    `url(#reverseArrowhead)`
                : null
            )
            .attr('stroke-dasharray', d => {
                const da = configuration.hasOwnProperty(d.type) && configuration[d.type]["stroke-dasharray"] ?
                    configuration[d.type]["stroke-dasharray"]
                    :
                    '';
                return da;
            })
            .attr('stroke', d => {
                const colour = configuration.hasOwnProperty(d.type) && configuration[d.type].colour ?
                    configuration[d.type].colour
                    :
                    '#000';
                return colour;
            })
            .attr('d', edgeCurve);

        edgepaths.attr('d', edgeCurve);
    }

    function computeLabel(data) {
        const propNames = ["prefLabel", "title", "label"];
        let label = data.id || "No title available";
        for (let i = 0; i < propNames.length; i++) {
            const name = propNames[i];
            if (data.hasOwnProperty(name)) {
                if (data[name].hasOwnProperty(viewLang)) {
                    label = data[name][viewLang];
                }
                else if (data[name].hasOwnProperty(defaultLang)) {
                    label = data[name][defaultLang];
                }
                else if (data[name].hasOwnProperty("und")) {
                    label = data[name]["und"];
                }
                else {
                    label = data.id;
                }
                break;
            }
        }
        return label;
    }

    function computeIsViewLang(data) {
        const propNames = ["prefLabel", "title", "label"];
        let isViewLang = false;
        for (let i = 0; i < propNames.length; i++) {
            const name = propNames[i];
            if (data.hasOwnProperty(name)) {
                isViewLang = data[name].hasOwnProperty(viewLang);
                break;
            }
        }
        return isViewLang;
    }

    function processData(resourceIRI, nodeData) {

        if (nodeData) {
            const data = cloneDeep(nodeData);
            return {
                id: resourceIRI,
                nodeClass: Array.isArray(data.type) ? data.type : [data.type],
                link: false,
                ...(data.iri) && { iri: data.iri },
                deprecated: data.deprecated,
                pendingDeletion: data.pendingDeletion,
                isViewLang: computeIsViewLang(data),
                label: computeLabel(data)
            };
        }
        else {
            return {
                id: resourceIRI,
                nodeClass: ["Resource"],
                link: true,
                isViewLang: true,
                label: resourceIRI
            };
        }
    }

    function computeNodesToRemove() {

        const removalList = nodeStore.filter(node => {
            if (node.id === originalNode) return false;
            return !linkStore.some(linkItem => linkItem.source === node.id || linkItem.target === node.id);
        }).map(node => node.id);

        return removalList;
    }

    async function getInboundToNode(node) {
        const inboundResults = await GS.search({
            search: [{
                predicate: configurationIRIs,
                value: node
            }],
            noCount: true,
            page: 1,
            pageSize: 100
        });
        if (inboundResults.results && inboundResults.results.length > 0) {
            const inboundNodes = inboundResults.results.map(result => result.id);
            const updatedData = await generateData(inboundNodes, false, node);
            const { linkData, nodeData } = updatedData;
            nodeStore = [...nodeStore, ...nodeData];
            linkStore = [...linkStore, ...linkData];
            render();
            tickActions();
        }
    }

    /**
     * @param {} nodes 
     * @param {*} processExisting For incoming updates we might need to update existing node data
     */
    async function generateData(nodes, processExisting = false, target) {

        let nodeData = [];
        let linkData = [];

        // Compute which resources need loading
        // We get a list to load in two goes
        // First we get the node list items - which will give us the relationships and objects we need to then load
        await GS.loadData(nodes, {}, graph);

        // Now load related resources
        let connectedResources = [];
        for (const sourceNode of nodes) {

            // This call should load from in-memory as resource now loaded
            const data = GS.data(sourceNode, graph, false);
            // Is node available?
            if (data) {
                for (const objProp of objectProperties) {
                    if (data[objProp]) {
                        if (Array.isArray(data[objProp])) {
                            for (const objItem of data[objProp]) {
                                const objItemId = typeof objItem === "object" ? objItem.id : objItem;
                                if (!nodeStore.some(dataItem => dataItem.id === objItemId)) {
                                    const alreadyListed = connectedResources.some(cr => cr.iri === objItemId);
                                    if (!alreadyListed) {
                                        connectedResources.push({
                                            iri: objItemId,
                                            graph
                                        });
                                    }
                                }
                            }
                        }
                        else {
                            const objItemId = typeof data[objProp] === "object" ? data[objProp].id : data[objProp];
                            if (!nodeStore.some(dataItem => dataItem.id === data[objProp])) {
                                const alreadyListed = connectedResources.some(cr => cr.iri === objItemId);
                                if (!alreadyListed) {
                                    connectedResources.push({
                                        iri: objItemId,
                                        graph
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }

        // Limit the data loading - stuff may already be loaded though
        if (connectedResources.length > 0 && connectedResources.length < MAX_CONNECTIONS) {
            let langs = [viewLang];
            if (defaultLang !== viewLang) langs.push(defaultLang);
            await GS.loadDataFromGraph(connectedResources, {
                language: langs,
                predicates: [
                    "http://www.w3.org/2000/01/rdf-schema#label",
                    "http://www.w3.org/2004/02/skos/core#prefLabel",
                    "http://www.w3.org/2008/05/skos-xl#prefLabel",
                    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                ],
                tests: [
                    {
                        id: "http://www.w3.org/2008/05/skos-xl#prefLabel",
                        join: [{
                            predicate: "http://www.w3.org/2008/05/skos-xl#literalForm"
                        }]
                    }
                ]
            });
        }

        for (const sourceNode of nodes) {

            const data = GS.data(sourceNode, graph, false);
            let overloaded = false;
            // Is node loaded?
            if (data) {

                // First create the connected nodes
                for (const objProp of objectProperties) {
                    if (data[objProp]) {
                        const dataArray = Array.isArray(data[objProp]) ? data[objProp] : [data[objProp]];
                        if (dataArray.length < MAX_CONNECTIONS) {
                            for (const objItem of dataArray) {
                                const objItemId = typeof objItem === "object" ? objItem.id : objItem;
                                if (!target || target === objItemId) {
                                    const exists = nodeStore.some(dataItem => dataItem.id === objItemId);
                                    const existsInData = nodeData.some(dataItem => dataItem.id === objItemId);
                                    if ((processExisting && !existsInData) || (!exists && !existsInData)) {
                                        const connectedData = GS.data(objItemId, graph, false);
                                        const processedData = processData(objItemId, connectedData);
                                        nodeData.push(processedData);
                                    }
                                }
                            }
                        }
                        else {
                            overloaded = true;
                        }
                    }
                }

                // Then create the links to those nodes
                let nodeLinkCount = {};
                for (const propIndex in objectProperties) {
                    const objProp = objectProperties[propIndex];
                    if (data[objProp]) {
                        const dataArray = Array.isArray(data[objProp]) ? data[objProp] : [data[objProp]];
                        if (dataArray.length < MAX_CONNECTIONS) {
                            for (const objItem of dataArray) {
                                const objItemId = typeof objItem === "object" ? objItem.id : objItem;
                                if (!target || target === objItemId) {
                                    const linkExists = linkStore.some(linkItem => {
                                        return linkItem.source === data.id
                                            && linkItem.target === objItemId && linkItem.type === objProp;
                                    });
                                    if (!linkExists) {
                                        const linkType = configuration.hasOwnProperty(objProp) ?
                                            configuration[objProp].iri
                                            :
                                            objProp;
                                        if (!nodeLinkCount[objItemId]) nodeLinkCount[objItemId] = 0;
                                        const exists = linkData.find(ld => ld.source === objItemId && ld.target === data.id);
                                        if (exists) {
                                            nodeLinkCount[objItemId] = nodeLinkCount[objItemId] + 1;
                                        }
                                        const inverseExists = linkStore.find(ld => ld.source === objItemId && ld.target === data.id);
                                        if (inverseExists) {
                                            nodeLinkCount[objItemId] = nodeLinkCount[objItemId] + 1;
                                        }
                                        linkData.push({
                                            "source": data.id,
                                            "nodeLinkIndex": nodeLinkCount[objItemId],
                                            "target": objItemId,
                                            "type": objProp,
                                            "typeLabel": linkType,
                                            "linkIndex": propIndex
                                        });
                                        nodeLinkCount[objItemId] = nodeLinkCount[objItemId] + 1;
                                    }
                                }
                            }
                        }
                        else {
                            overloaded = true;
                        }
                    }
                }

                const exists = nodeStore.some(dataItem => dataItem.id === sourceNode);
                const existsInData = nodeData.some(dataItem => dataItem.id === sourceNode);
                if ((processExisting && !existsInData) || (!exists && !existsInData)) {
                    const processedData = processData(sourceNode, data);
                    if (overloaded) processedData.overloaded = true;
                    nodeData.push(processedData);
                }

            }
        }

        return {
            nodeData,
            linkData
        };
    }

    function showTooltip(event, htmlText, xOffset = 10, yOffset = 0) {
        if (!showTooltips) return;
        div.transition()
            .duration(200)
            .style("opacity", 1);
        div.html(htmlText)
            .style("left", (event.pageX + xOffset) + "px")
            .style("top", (event.pageY + yOffset) + "px");
    }

    function hideTooltop(duration = 200) {
        div.html("");
        div.transition()
            .duration(duration)
            .style("opacity", 0);
    }

    function addMarkers() {
        svg.append('defs').append('marker')
            .attr('id', 'arrowhead')
            .attr('viewBox', '-0 -5 10 10')
            .attr('refX', 28)
            .attr('refY', 0)
            .attr('orient', 'auto-start-reverse')
            .attr('markerWidth', 18)
            .attr('markerHeight', 18)
            .attr('xoverflow', 'visible')
            .append('svg:path')
            .attr('d', 'M 0,-5 L 10 ,0 L 0,5')
            .attr('fill', '#000')
            .attr('fill-opacity', 0.5)
            .style('stroke', 'none');

        svg.append('defs').append('marker')
            .attr('id', 'reverseArrowhead')
            .attr('viewBox', '-0 -5 10 10')
            .attr('refX', 28)
            .attr('refY', 0)
            .attr('orient', 'auto-start-reverse')
            .attr('markerWidth', 18)
            .attr('markerHeight', 18)
            .attr('xoverflow', 'visible')
            .append('svg:path')
            .attr('d', 'M 0,-5 L 10 ,0 L 0,5')
            .attr('fill', '#000')
            .attr('fill-opacity', 0.5)
            .style('stroke', 'none');

        Object.keys(configuration).forEach(configType => {
            if (configuration[configType].colour) {
                svg.append('defs').append('marker')
                    .attr('id', 'arrowhead-' + configType)
                    .attr('viewBox', '-0 -5 10 10')
                    .attr('refX', 28)
                    .attr('refY', 0)
                    .attr('orient', 'auto-start-reverse')
                    .attr('markerWidth', 18)
                    .attr('markerHeight', 18)
                    .attr('xoverflow', 'visible')
                    .append('svg:path')
                    .attr('d', 'M 0,-5 L 10 ,0 L 0,5')
                    .attr('fill', configuration[configType].colour)
                    .attr('fill-opacity', 0.5)
                    .style('stroke', 'none');

                svg.append('defs').append('marker')
                    .attr('id', 'reverseArrowhead-' + configType)
                    .attr('viewBox', '-0 -5 10 10')
                    .attr('refX', 28)
                    .attr('refY', 0)
                    .attr('orient', 'auto-start-reverse')
                    .attr('markerWidth', 18)
                    .attr('markerHeight', 18)
                    .attr('xoverflow', 'visible')
                    .append('svg:path')
                    .attr('d', 'M 0,-5 L 10 ,0 L 0,5')
                    .attr('fill', configuration[configType].colour)
                    .attr('fill-opacity', 0.5)
                    .style('stroke', 'none');
            }
        });
    }

    function addZoomControls() {

        zoomHandler = d3.zoom()
            .on("zoom", (event) => g.attr("transform", event.transform));
        zoomHandler(svg);
        zoomEnabled = true;
        // Disable double click zoom behaviour as we control it through the buttons
        svg.on("dblclick.zoom", null);

        const zoomIn = svg.append("g")
            .attr("class", "visual-zoomButton")
            .attr("data-test", "zoom-in")
            .on("mouseover", (event) => showTooltip(event, "Zoom in", 0, 20))
            .on("mouseout", hideTooltop)
            .on("click", () => {
                if (zoomEnabled && zoomFactor < 5) {
                    zoomEnabled = false;
                    zoomFactor++;
                    zoomHandler.scaleTo(svg.transition()
                        .duration(750)
                        .on("end", () => {
                            zoomEnabled = true;
                        })
                        .on("interrupt", () => {
                            zoomEnabled = true;
                        }),
                        zoomFactor === 1 ? 1 : zoomFactor);
                    if (zoomFactor === 5) {
                        zoomIn.classed('visual-zoomDisabled', true);
                    }
                    zoomOut.classed('visual-zoomDisabled', false);
                }
            });

        zoomIn
            .append("rect")
            .attr("x", 15)
            .attr("y", 15)
            .attr("height", 30)
            .attr("width", 30)
            .attr("fill", "transparent");

        zoomIn.append("path")
            .attr("class", "visual-zoomIcon")
            .attr("d", "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z")
            .attr("transform", "scale(1.2) translate(12 18)");
        zoomIn.append("path")
            .attr("class", "visual-zoomIcon")
            .attr("d", "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z")
            .attr("transform", "scale(1.2) translate(12 18)");

        const zoomOut = svg.append("g")
            .attr("class", "visual-zoomButton")
            .attr("data-test", "zoom-out")
            .on("mouseover", (event) => showTooltip(event, "Zoom out", 0, 20))
            .on("mouseout", hideTooltop)
            .on("click", () => {
                if (zoomEnabled && zoomFactor > 0) {
                    zoomEnabled = false;
                    zoomFactor--;
                    zoomHandler.scaleTo(svg.transition()
                        .duration(750)
                        .on("end", () => {
                            zoomEnabled = true;
                        })
                        .on("interrupt", () => {
                            zoomEnabled = true;
                        }),
                        zoomFactor < 1 ? 0.75 : zoomFactor);
                    if (zoomFactor === 0) {
                        zoomOut.classed('visual-zoomDisabled', true);
                    }
                    zoomIn.classed('visual-zoomDisabled', false);
                }
            });

        zoomOut
            .append("rect")
            .attr("x", 54)
            .attr("y", 15)
            .attr("height", 30)
            .attr("width", 30)
            .attr("fill", "transparent");

        zoomOut.append("path")
            .attr("class", "visual-zoomIcon")
            .attr("d", "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z")
            .attr("transform", "scale(1.2) translate(36 18)");

    }

    function initiate() {

        g = svg.append("g");

        addMarkers();
        addZoomControls();

        const linkForce = d3.forceLink([])
            .id(d => d.id)
            .distance(250);

        simulation = d3.forceSimulation([])
            .force("charge", d3.forceManyBody())
            .force("links", linkForce)
            .force("center", d3.forceCenter(width / 2, height / 2))
            .force('collision', d3.forceCollide(radius * 2))
            .alphaTarget(ALPHA_TARGET)
            .on("tick", tickActions);

        link = g.append("g").selectAll(".link");

        node = g.append("g")
            .attr("data-test", "node-group")
            .selectAll(".node");
        edgepaths = g.append("g")
            .attr("data-test", "edge-paths")
            .selectAll(".edgepath");
        edgelabels = g.append("g")
            .attr("data-test", "edge-labels")
            .selectAll(".edgelabel");
    }

    function addNodeStatus(d) {
        if (d.deprecated === true) {
            d3.select(this)
                .append("tspan")
                .attr("class", "visual-deprecated")
                .text(" (Deprecated)");
        }
        else if (d.pendingDeletion === true) {
            d3.select(this)
                .append("tspan")
                .attr("class", "visual-deleted")
                .text(" (Pending deletion)");
        }
    }

    function addCurrentIRI(event, d) {
        const currentIRI = d.iri ?
            d.iri[d.iri.length - 1]
            :
            d.id;
        let text = `<span data-test="current-iri">${currentIRI}</span>`;
        if (d.nodeClass) {
            let classText = d.nodeClass.sort().map(nc => {
                let cc = CLASS_CONFIGURATION.find(cc => cc.type === nc);
                if (cc) return `<span style="display: block">${cc.text}</span>`
                return `<span style="display: block">${nc}</span>`;
            }).join("");
            text = `<span><span style="display: block" data-test="current-iri">${currentIRI}</span><span data-test="node-class" style="display: block; margin-top: 12px">${classText}</span></span>`;
        }
        showTooltip(event, text);
    }

    function addNodeVisualisation(d, nodeGroup) {
        const visConfigInfo = CLASS_CONFIGURATION.find(cc => {
            return d.nodeClass.includes(cc.type);
        });
        let defaultGraphic = true;
        if (visConfigInfo) {
            if (visConfigInfo.text) defaultGraphic = false;
        }
        nodeGroup
            .append("circle")
            .attr("data-test", "node-circle")
            .attr("class", d.nodeClass.map(classItem => "visual-" + classItem).join(" "))
            .attr("r", radius);
        if (defaultGraphic) {
            nodeGroup
                .append("path")
                .attr("d", "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z")
                .attr("transform", "translate(-24 -24) scale(2 2)")
                .attr("fill", "#fff");
        }
        else {
            if (visConfigInfo.svg) {
                nodeGroup
                    .append("path")
                    .attr("d", visConfigInfo.svg)
                    .attr("transform", visConfigInfo.transform)
                    .attr("fill", "#fff");
            }
            else {
                nodeGroup.append("text")
                    .attr("dx", visConfigInfo.x)
                    .attr("dy", visConfigInfo.y)
                    .text(visConfigInfo.text);
            }
        }
    }

    function render() {

        // Apply the general update pattern to the links.
        const linkCopy = cloneDeep(linkStore);
        link = link.data(linkCopy, function (d) { return d.source.id + "-" + d.target.id + "-" + d.type; });
        link.exit().remove();
        link = link.enter()
            .append("path")
            .attr("class", "visual-link")
            .call(function (link) { link.transition().attr("stroke-opacity", 1); })
            .merge(link);

        edgepaths = edgepaths.data(linkCopy, function (d) { return d.source.id + "-" + d.target.id + "-" + d.type; });
        edgepaths.exit().remove();
        edgepaths = edgepaths.enter()
            .append('path')
            .attr('class', 'visual-edgepath')
            .attr('fill-opacity', 0)
            .attr('stroke-opacity', 0)
            .attr('id', function (d, i) { return 'edgepath' + i; })
            .style("pointer-events", "none")
            .merge(edgepaths);

        edgelabels = edgelabels.data(linkCopy, function (d) { return d.source.id + "-" + d.target.id + "-" + d.type; });
        edgelabels.exit().remove();
        edgelabels = edgelabels.enter()
            .append('text')
            .on("mouseover", (event, d) => showTooltip(event, d.typeLabel))
            .on("mouseout", hideTooltop)
            .attr('class', 'visual-edgelabel')
            .attr('id', function (d, i) { return 'edgelabel' + i; })
            .attr('data-test', function (d, i) { return 'edgelabel' + i; })
            .attr("title", d => d.type)
            .each(function (d, i) {
                d3.select(this)
                    .append('textPath')
                    .attr("data-test", "label-text")
                    .on("mouseover", (event, d) => showTooltip(event, d.type))
                    .on("mouseout", hideTooltop)
                    .attr('xlink:href', '#edgepath' + i)
                    .style("text-anchor", "middle")
                    .attr("startOffset", "50%")
                    .text(function (d) {
                        if (configuration.hasOwnProperty(d.type) && configuration[d.type].displayName) {
                            return configuration[d.type].displayName
                                ;
                        }
                        else {
                            const shortName = d.type.includes('#') ?
                                decodeURIComponent(d.type.substring(d.type.lastIndexOf('#') + 1))
                                :
                                decodeURIComponent(d.type.substring(d.type.lastIndexOf('/') + 1));
                            return shortName;
                        }
                    });
            })
            .merge(edgelabels);

        // Apply the general update pattern to the nodes.
        node = node.data(nodeStore, d => d.id);

        // We need this line for updates from other users
        node.select(".visual-nodeText")
            .attr("class", d => d.isViewLang ? "visual-nodeText visual-nodeTextDefault" : "visual-nodeText visual-nodeTextNonDefault")
            .text(d => d.label)
            .each(addNodeStatus);

        // Need to handle updated IRI
        node.select(".visual-nodeGroup").on("mouseover", addCurrentIRI);

        node.exit().remove();

        const newNodes = node.enter()
            .append("g")
            .attr("data-test", "node")
            .call(d3.drag()
                .on("start", function (event, d) {
                    showTooltips = false;
                    hideTooltop(0);
                    if (!event.active) simulation.alphaTarget(0.3).restart();
                    d.fx = d.x;
                    d.fy = d.y;
                })
                .on("drag", function (event, d) {
                    d.fx = event.x;
                    d.fy = event.y;
                })
                .on("end", function () {
                    showTooltips = true;
                })
            )
            .each(function (d) {
                // Add event handling.
                if (GS.isLoaded(d.id, graph)) {
                    const monitorGuid = GS.bindChange(d.id, graph, handleGSevent);
                    monitorGuids.push(monitorGuid);
                    monitorIRIs.push(d.id);
                }
                const nodeGroup = d3.select(this)
                    .append("g")
                    .attr("class", "visual-nodeGroup")
                    .attr("data-test", "node-" + d.id);
                if (d.id === originalNode) {
                    nodeGroup
                        .append("circle")
                        .attr("r", radius * 1.5);
                }
                addNodeVisualisation(d, nodeGroup);
                nodeGroup
                    .on("mouseover", addCurrentIRI)
                    .on("mouseout", hideTooltop);
                if (d.link) {
                    d3.select(this)
                        .append("svg:a")
                        .attr("xlink:href", d => d.label)
                        .attr("class", "visual-hyperlink")
                        .attr("target", "_blank")
                        .append("text")
                        .attr("dy", -18)
                        .text(d => d.label);
                }
                else {
                    d3.select(this)
                        .append("text")
                        .attr("dy", d.id === originalNode ? -34 : -32)
                        .attr("data-test", "text-" + d.id)
                        .attr("class", d.isViewLang ? "visual-nodeText visual-nodeTextDefault" : "visual-nodeText visual-nodeTextNonDefault")
                        .text(d => d.label)
                        .each(addNodeStatus);
                }
                if (d.overloaded) {
                    d3.select(this)
                        .append("text")
                        .attr("data-test", "too-many-relationships")
                        .attr("dx", 20)
                        .attr("dy", 20)
                        .attr("class", "visual-warning")
                        .text("Too many connections on some relationships.");
                }
            })
            .on("click", function (event, d) {
                if (event.ctrlKey) {
                    getInboundToNode(d.id);
                }
                else {
                    if (resources.includes(d.id)) {
                        removeNode(d.id);
                    }
                    else {
                        addNode(d.id);
                    }
                }
            });

        node = newNodes.merge(node);
        simulation.nodes(nodeStore);
        simulation.force("links").links(linkCopy);
    }

    async function create(sourceNode) {
        resources.push(sourceNode);
        const updatedData = await generateData([sourceNode]);
        const { linkData, nodeData } = updatedData;
        nodeStore = [...nodeData];
        linkStore = [...linkData];
        initiate();
        render();
        loadCallback(sourceNode);
    }

    async function addNode(sourceNode) {
        resources.push(sourceNode);
        const updatedData = await generateData([sourceNode]);
        const { linkData, nodeData } = updatedData;
        nodeStore = [...nodeStore, ...nodeData];
        linkStore = [...linkStore, ...linkData];
        render();
        tickActions();
        loadCallback(sourceNode);
    }

    async function removeNode(nodeToRemove) {
        resources.splice(resources.indexOf(nodeToRemove), 1);
        return update(objectProperties);
    }

    async function update(updatedObjectProperties) {
        objectProperties = updatedObjectProperties;
        // We remove all links and recompute them
        linkStore = [];
        const updatedData = await generateData(resources);
        const { linkData, nodeData } = updatedData;
        nodeStore = [...nodeStore, ...nodeData];
        linkStore = [...linkData];
        const rl = computeNodesToRemove();
        if (rl.length > 0) {
            nodeStore = nodeStore.filter(node => !rl.includes(node.id));
        }
        render();
        tickActions();
    }

    // We update for all events
    async function handleGSevent() {
        linkStore = [];
        const updatedData = await generateData(resources, true);
        const nodeCopy = cloneDeep(nodeStore);
        const { linkData, nodeData } = updatedData;
        // We need to know which nodes have been updated and filter those out
        const untouchedNodes = nodeCopy.filter(node => !nodeData.some(updatedNode => updatedNode.id === node.id));
        nodeStore = [...untouchedNodes, ...nodeData];
        linkStore = [...linkData];
        const rl = computeNodesToRemove();
        if (rl.length > 0) {
            nodeStore = nodeStore.filter(node => !rl.includes(node.id));
        }
        render();
        tickActions();
    }

    function stop() {
        simulation.stop();
    }

    function restart() {
        simulation.restart();
    }

    function unbindEvents() {
        monitorGuids.forEach((guid, index) => {
            const iri = monitorIRIs[index];
            GS.unbind(iri, graph, guid);
        });
    }

    async function reset(updatedObjectProperties) {
        objectProperties = updatedObjectProperties;
        simulation.stop();
        unbindEvents();
        resources = [];
        linkStore = [];
        nodeStore = [];
        node = [];
        link = [];
        edgepaths = [];
        edgelabels = [];
        svg.selectAll("*").remove();
        svg.call(zoomHandler.transform, d3.zoomIdentity);
        zoomFactor = 1;
        zoomEnabled = true;
        create(originalNode);
    }

    function destroy() {
        unbindEvents();
    }

    await create(originalNode);

    return {
        stop,
        restart,
        update,
        reset,
        destroy
    };
}

export default createVisual;